import { render, staticRenderFns } from "./graduationAdmin.vue?vue&type=template&id=ea298a3a&scoped=true"
import script from "./graduationAdmin.vue?vue&type=script&lang=js"
export * from "./graduationAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea298a3a",
  null
  
)

export default component.exports